import React from "react";
import clientConfigApi from '../config/config'
import { globalIV, globalSalt } from "../config/constant";
import { AesUtil } from "../JS/AesUtil";


let aesUtil = new AesUtil(128, 1000);

// Function to group payload by dates
const groupByDate = (payload) => {
    const grouped = payload.reduce((acc, item) => {
        const itineraryDate = item.itineraryDateTime.split(' ')[0]; // Extract the date part
        const existingGroup = acc.find(group => group.itineraryDate === itineraryDate);
        if (existingGroup) {
            existingGroup.itineraries.push(item);
        } else {
            acc.push({ itineraryDate, itineraries: [item] });
        }
        return acc;
    }, []);
    return grouped;
};


export const getGuestItinerary = () => {
    if (process.env.REACT_APP_DISABLE_ITINERARY_API == "true") {
        return () => {};
    }

    return async dispatch => {

        let payload = {}


        const preCheckInDetails = (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) && JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")))

        const room = localStorage.getItem('room');
        if((!room || room === "null")){
            if(!preCheckInDetails){
                return
            }
        }
        
        payload = {
            confirmationNumber : preCheckInDetails && preCheckInDetails.confirmationNumber,
            guestLastName: preCheckInDetails && preCheckInDetails.lastName
        }
        

        let requestPayload = {
            "header": {
                "sessionToken": localStorage.getItem("GuestJourneySessionToken")
            },
            "payload": payload
        }

        try {
            clientConfigApi.post(`/guest/itinerary`, requestPayload)
                .then((res) => {
                    dispatch({
                        type: "UPDATE_GUEST_ITINERARY_STATUS",
                        payload: {
                            status: "SUCCESS",
                            payload: groupByDate(res.data && res.data.payload && res.data.payload.payload)
                        }
                    })
                })
                .catch((err) => {

                    dispatch({
                        type: "UPDATE_GUEST_ITINERARY_STATUS",
                        payload: {
                            status: "FAILED",
                            errorMessage: err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg
                        }
                    })
                })
        } catch (error) {
            dispatch({
                type: "UPDATE_GUEST_ITINERARY_STATUS",
                payload: {
                    status: "FAILED",
                    errorMessage: ""
                }
            })
        }
    }
}